import { FolderTreeNode } from '../../../typescript-angular-client/model/folderTreeNode';

export const matchNode = (id: string, folder: FolderTreeNode): FolderTreeNode => {
  let node : FolderTreeNode;
  folder.children.forEach(child => {
    if (child.key === id) {
      node = child;
    };
    if (!node) {
      node = matchNode(id, child);
    };
  });
  return node;
}
